// config.js
const baseURL = 'https://apic.rasutrip.com/api/v1';
export default baseURL;
